import GatewayCommentRequests from 'app/requests/GatewayComment.requests'
import CommentsLog from 'app/shared-components/CommentsLog'
import useGetGatewayComments from './hooks/useGetGatewayComments'
import useRemoveGatewayComment from './hooks/useRemoveGatewayComment'
import useStyles from './GatewayComment.style'

const GatewayComments = ({
    gatewayId,
}: {
    gatewayId: number,
}) => {
    const {
        classes,
    } = useStyles()

    const {
        onParamsChange,
        loadData,
        refetch,
    } = useGetGatewayComments(gatewayId)

    const deleteComment = useRemoveGatewayComment({
        onSuccess: refetch,
    })

    return (
        <CommentsLog
            requestConfigCreate={GatewayCommentRequests.create({
                gatewayId,
            })}
            deleteComment={deleteComment}
            onParamsChange={onParamsChange}
            loadData={loadData}
            refetch={refetch}
            sorting={false}
            className={classes.root}
        />
    )
}

export default GatewayComments
